import { first } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'motes-modal',
    templateUrl: './motes-modal.component.html',
    styleUrls: ['./motes-modal.component.scss']
})
export class MotesModalComponent implements OnInit {

    public _showOverlay: boolean = false;
    public loading: boolean = false;

    @Input() set show(show: boolean) {
        if(show == this._showOverlay) return;
        this._showOverlay = show;
    }
    @Input() selectedValues: Array<any> = [];
    @Input() closeOnClick: boolean = false;

    @Output() selectionDone = new EventEmitter<any | null>();

    public showSelect(): Promise<any> {
        this.show = true;
        return this.selectionDone.pipe(first()).toPromise();
    }

    constructor() { }

    ngOnInit() {
    }

    public cancel() {
        this.show = false;
        this.selectionDone.emit(null);
    }

    public confirm() {
        this.show = false;
        this.selectionDone.emit(this.selectedValues);
    }

    public overlayClick() {
        if(this.closeOnClick) {
            this.selectionDone.emit(this.selectedValues);
        }
    }
}
